import { useQuery } from "@tanstack/react-query";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { api } from "utils/api";

export interface LoanTypeForTheTenantModel {
  id: number;
  title: string;
  description: string;
}

const fetchLoanTypes = async (): Promise<LoanTypeForTheTenantModel[]> => {
  const { data } = await api.get<LoanTypeForTheTenantModel[]>(`/tenant/loan-types`);

  return data;
};

export function useLoanTypesForTheTenant() {
  const { user } = useTenant();

  return useQuery({
    queryKey: ["loan-types", user.lender_company.id],
    queryFn: () => fetchLoanTypes(),
    enabled: !!user.lender_company.id,
  });
}
